import { render, staticRenderFns } from "./ComponentGroupView.vue?vue&type=template&id=17bc529a&scoped=true"
import script from "./ComponentGroupView.vue?vue&type=script&lang=js"
export * from "./ComponentGroupView.vue?vue&type=script&lang=js"
import style0 from "./ComponentGroupView.vue?vue&type=style&index=0&id=17bc529a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc529a",
  null
  
)

export default component.exports